import { categoryLabel } from '../../admin/lib/category';
import type { SignupDraft } from './draft';

const PLACEHOLDER_NAME = 'Tu negocio';

/**
 * The business as its customers will meet it in Dale, assembling itself as
 * the answers come in. Each line appears the first time it has something to
 * say; nothing here is invented (no ratings, no photos we do not have).
 */
export function LivePreview({ draft, celebrating }: { draft: SignupDraft; celebrating?: boolean }) {
  const name = draft.businessName.trim();
  const initial = (name || PLACEHOLDER_NAME).charAt(0).toLocaleUpperCase('es-PA');
  const place = [draft.category ? categoryLabel(draft.category) : null, draft.neighborhood].filter(Boolean).join(' · ');
  const today = todayHours(draft);
  return (
    <figure className="wiz-card-wrap" data-celebrating={celebrating ? 'true' : undefined}>
      {celebrating ? <Sparks /> : null}
      <div className="wiz-card">
        <div className="wiz-card-top">
          <span className="wiz-card-mark" aria-hidden="true">
            {initial}
          </span>
          <div className="wiz-card-titles">
            <p className="wiz-card-name" data-empty={name ? undefined : 'true'}>
              {name || PLACEHOLDER_NAME}
            </p>
            {place ? (
              <p className="wiz-card-line" key={place}>
                {place}
              </p>
            ) : null}
          </div>
        </div>
        {draft.address.trim() ? <p className="wiz-card-detail">{draft.address.trim()}</p> : null}
        {today ? <p className="wiz-card-detail">{today}</p> : null}
        <span className="wiz-card-cta" aria-hidden="true">
          Reservar
        </span>
      </div>
      <figcaption className="wiz-card-caption">Así te verán tus clientes en Dale.</figcaption>
    </figure>
  );
}

function todayHours(draft: SignupDraft): string | null {
  const day = draft.hours.find((row) => row.dayOfWeek === new Date().getDay());
  if (!day) return null;
  return day.isClosed ? 'Hoy cerrado' : `Hoy de ${day.opensAt} a ${day.closesAt}`;
}

const SPARK_COUNT = 14;

/** A small burst of copper when the business is created. Decorative; hidden from assistive tech and reduced motion. */
function Sparks() {
  return (
    <span className="wiz-sparks" aria-hidden="true">
      {Array.from({ length: SPARK_COUNT }, (_, index) => (
        <span key={index} style={{ ['--a' as string]: `${(360 / SPARK_COUNT) * index}deg`, ['--d' as string]: `${index % 3}` }} />
      ))}
    </span>
  );
}
